<div #dashboard class="grid-container dashboard pb-32 h100">
  <ktd-grid
    [cols]="column()"
    [gap]="16"
    [rowHeight]="rowHeight() ?? 150"
    [layout]="widgets()"
    compactType="vertical"
    [preventCollision]="false"
    [scrollableParent]="containerElement"
    [scrollSpeed]="10"
    (dragStarted)="dragging = true"
    (dragEnded)="dragging = false"
    (layoutUpdated)="onLayoutUpdated($event)">
    @for (item of widgets(); track item.id) {
      <ktd-grid-item transition="transform 500ms ease, width 500ms ease, height 500ms ease"
                     [ngClass]="{'item-editable': edition(), 'item-non-editable': !edition()}"
                     [id]="item.id"
                     [dragStartThreshold]="30"
                     [draggable]="true"
                     [resizable]="false">
        <div class="grid-item-content" [attr.data-testid]="'dashboard-widget-' + item.type">
          <vl-widget-container [widget]="item" [customLoading]="customLoading()" [editable]="editable()">
            <div class="drag-handler">
              <div ktdGridDragHandle class="cursor-grab align-center">
                <mat-icon>drag_indicator</mat-icon>
              </div>
            </div>
          </vl-widget-container>
        </div>
        <ng-template ktdGridItemPlaceholder>
          <div class="w100 h100 border-8 bg-background-alt"></div>
        </ng-template>
      </ktd-grid-item>
    }
  </ktd-grid>
</div>
